import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRICE_LIST_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deletePriceListAction = createAsyncThunk(
    'price/deletePriceListAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ PRICE_LIST_PATH }/${ id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deletePriceListSlice = createSlice({
    name: 'deletePriceListSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deletePriceListAction.pending, () => STATE__API__STARTED);
        builder.addCase(deletePriceListAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deletePriceListAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deletePriceListState = (state) => state.price.deletePriceList;
export default deletePriceListSlice.reducer;
